<template>
  <div class="draw-rule-popup-component">
    <ym-popup class="draw-rule-popup"
              v-model="visible"
              popup-transition="popup-fade"
              get-container="body"
    >

      <div class="draw-rule-popup-content">
        <div class="draw-rule-popup-header">
          活动规则
        </div>
        <div class="draw-rule-popup-container">
          <div class="draw-rule-popup-container-rule-item"
               v-for="(item,index) in rule"
               :key="index"
          >
            {{ index + 1 }}.{{ item }}
          </div>
        </div>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'DrawRulePopup',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      rule: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClickClose(e) {
        this.visible = false;
        this.$emit('closed', e);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .draw-rule-popup {
    box-sizing: border-box;
    width: 600px;
    background: transparent;
    &-header {
      width: 100%;
      height: 104px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-white;
      font-weight: @font-weight-bold;
      font-size: 45px;
      background: #f75748;
      border-radius: 20px 20px 0 0;
    }
    &-container {
      width: 100%;
      max-height: 700px;
      overflow: scroll;
      padding: 60px 40px 86px 38px;
      box-sizing: border-box;
      color: #333;
      font-size: 26px;
      line-height: 45px;
      background: @color-white;
      border-radius: 0 0 20px 20px;
      &-rule-item {
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
